<template>
	<!-- Popup Warning -->
	<div v-if="show" class="schedule-popup-overlay">
		<div class="schedule-popup">
			<div class="popup-body">
				<span>Exit without Saving ?</span>
			</div>
			<div class="popup-footer">
				<button class="popup-button" @click.prevent="$emit('cancel')">
					<span class="btn-text">Cancel</span>
				</button>
				<button class="popup-button" @click.prevent="$emit('exit')">
					<span class="btn-text">Exit</span>
				</button>
				<button
					class="popup-button"
					:class="{ 'popup-button-disabled': disableSave }"
					:disabled="disableSave"
					@click.prevent="$emit('save')"
				>
					<span class="btn-text">Save</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		close() {
			this.$emit('close')
		},
	},
	name: 'PanelPopup',

	props: {
		show: {
			type: Boolean,
			required: true,
		},
		disableSave: {
			type: Boolean,
			default: false,
		},
	},

	emits: ['exit', 'cancel', 'save'],

	data() {
		return {
			popupBox: false,
		}
	},
}
</script>

<style scoped>
.popup-button-disabled {
	opacity: 0.5;
	cursor: not-allowed !important;
}
</style>
